import VISA from './images/VSA.png';
import MASTERCARD from './images/MSC.png';
import JCB from './images/JCB.png';
import UPI from './images/UPI.png';
import { isNullOrUndefined } from 'util';
import numeral from 'numeral';

export const CREDIT_CARD = 'credit';
export const DIRECT_DEBIT = 'debit';
export const INDIVIDUAL = "I";
export const CORPORATE = "C";

export const exportFileType = {
    CSV : "csv",
    EXCEL : "xlsx",
    PDF : "pdf"
}

export const DEFAULT_DATE_RANGE = 360;
export const DEFAULT_DATE_EXPORT_RANGE = 30;


export const regEx = {
    PASSWORD : "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#\\$&\\*])[A-Za-z\\d!@#\\$&\\*]{8,}$",
    ALPHANUMERIC : "^[a-zA-Z0-9\\-_., ()']+?$",
    ALPHABET : "^[a-zA-Z\\-]+$",
    PERCENTAGE : "^[0-9]{1,2}(\\.[0-9]{1,2})*$",
    DECIMAL : "^[0-9]+(\\.([0-9]{1,2}))?$",
    NUMERIC : "^[0-9]+?$",
    EMAIL : "^([a-zA-Z0-9!#$%&'*+/=?^_`{}:.()~\\[\\]-]+@([a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+\\.)+[a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+)*$",
    MULTIPLE_EMAIL: "^([a-zA-Z0-9!#$%&'*+/=?^_`{}:.()~\\[\\]-]+@([a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+\\.)+[a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+)+(;[a-zA-Z0-9!#$%&'*+/=?^_`{}:.()~\\[\\]-]+@([a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+\\.)+[a-zA-Z0-9!#$%&'*/=?^`{}:.()~\\[\\]-]+)*$",
    URL : "https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&\\/\\/=]*)"
}

const paymentChannelLogo = {
    VISA : VISA,
    MASTERCARD : MASTERCARD,
    JCB : JCB,
    UPI : UPI
};

const labelChange = {
    contactNumber: "Contact number",
    email: "Email",
    fullName: "Full name",
    note: "Note",
    status: "Status",
    username: "Username",
    account: "Account",
    overview: "Overview",
    profile: "Profile",
    customerProfile: "customer",
    user: "User",
    report: "Report",
    refund: "Refund",
    settlement: "Settlement",
    transaction: "Transaction",
    approveRefund: "Approve refund",
    settle: "Settle",
    viewAll: "View all",
    voidTrans: "Void",
    Y: "Yes",
    N: "No",
    true: "Yes",
    false: "No",
    mTotalTranAmount: "Total Transaction Amount / Day",
    isTranAlert: "Alert When Total Amount Reach",
    amountPercentage: "Percentage Amount to Alert",
    cTotalTranCard: "Total Transaction / Day / Card",
    cTotalTranAmount: "Total Transaction Amount / Day / Card",
    maximumTranAmount: "Maximum Transaction Amount",
    otpAmount: "Amount for OTP",
    isOtpProcess: "OTP Process Required",
    merchantProfile: "Merchant Profile",
    visaMaster: "Standard Card Payment",
    is3DSecure: "3D Secure",
    isCvvWaive: "Waive CVV",
    unionPay: "UnionPay",
    isSubscribed: "Subscription",
    merchantCreditProfile: "Profile",
    autoAction: "Auto Settlement Action",
    noManualSettlement: "No. of Days",
    surchargeMerchant: "Surcharge",
    merchantInfo: "Info",
    b2kId: "B2K ID",
    callbackUrl: "Callback URL",
    contactFirstName: "Contact Firstname",
    contactLastName: "Contact Lastname",
    contactPhone: "Contact Phone No.",
    emailNotification: "Email Notification",
    mccCode: "MCC", 
    merchantContactMail: "Contact Email",
    merchantLogoFileName: "Merchant Logo",
    merchantName: "Merchant Name",
    merchantNameTrade: "Trading Name",
    tokenization: "Card Tokenization",
    merchantDDProfile: "Profile",
    certificateFileName: "Certificate",
    defaultPmtPage: "Default Payment Page",
    isAllowSchedulePmt: "Schedule Payment",
    isCheckCustRef: "Check Customer reference",
    isEncryptResp: "Encrypt Response",
    stmtDisplayOpt: "Statement Display",
    categoryId: "Merchant Category",
    businessTypeId: "Business Type",
    businessTypeCode: "Code",
    businessTypeDesc: "Description",
    waiveInfo: "Waiver / Rebate",
    waiveBy: "Waive By",
    waiveFlag: "Waive Flag",
    waiveType: "Waive Type",
    waiveFrom: "Waive From",
    waiveTo: "Waive To",
    waiveAmt: "Waive Amount",
    waivePercentage: "Waive Percentage",
    isAlwaysValid: "Valid till canceled",
    customerInfo: "Customer Info.",
    phoneNumber: "Phone Number",
    customerPaymentInfo: "Payment Info.",
    prefix: "Prefix",
    userId: "User ID",
    customerId : "Customer ID",
    corpName : "Company Name",
    corpId : "Corporate ID",
    feeProfile: "Fee Profile",
    chargeFrequency: "Frequency",
    chargeTo : "Charge to",
    minCharge : "Mininum Fee Amount",
    maxCharge : "Maximum Fee Amount",
    isRcvDebitAdvMail : "Debit Advice Mail Receive?",
    debitAdvRcvMail : "Debit Advice Mail",
    feeIBIRRequest : "Fee Option",
    isIB: "Apply IB fee",
    ibCalType : "IB Calculation Type",
    isIBCap: "IB fee on the basis of cap amount",
    ibFlatFeeAmt: "IB Fee Amount",
    ibPercentage: "IB Fee Percentage",
    ibCapType : "IB Capital Option",
    ibCapAmt : "IB Capital Amount",
    isIR: "Apply IR fee",
    irCalType : "IR Calculation Type",
    isIRCap: "IR fee on the basis of cap amount",
    irFlatFeeAmt: "IR Fee Amount",
    irPercentage: "IR Fee Percentage",
    irCapType : "IR Capital Option",
    irCapAmt : "IR Capital Amount",
    addressSeqId : "Address ID",
    isWaived: "Waive flag",
    isValidTillCancel: "Valid till canceled",
    feeWaiveRequest: "Waiver",
    redirectPaymentOption : "Redirect Payment Option",
    corporateCustomer : "Corporate Customer",
    retailCustomer : "Retail Customer",
    paymentGateway : "Payment Gateway",
    businessAnywhere : "Business Anywhere",
    businessNet : "Business Net",
    corporatePortal : "Corporate Portal",
    easyNet : "Easy Net",
    easyApp : "Easy App",
    epayment : "e-Payment",
    transactionReport : "Transaction",
    registrationReport : "Registration",
    onlineRegistrationReport : "Online Registration Monitoring",
    transactionRecurringReport: "Scheduled Transaction",
    summaryPaymentTransactionByStatus: "Summary by Status",
};

export const toDecimalFormat = (num) => {
    if(isNullOrUndefined(num) || num === ""){
        return num;
    } else {
        return numeral(num).format('0.00')
    }
}

export const getCategoryType = (role) => {
    if (role.includes("CC_")) {
        return "CC";
    } else if (role.includes("DD_")) {
        return "DD";
    } else {
        return "";
    }
}

export const getCalculationType = (calculationType) => {
    if (calculationType === "P") {
        return "Percentage";
    } else if (calculationType === "F") {
        return "Fix flat rate";
    } else if (calculationType === "FP") {
        return "Fix flat rate + Percentage";
    } else{
        return "";
    }
}

export const getChargeTo = (chargeTo) => {
    if (chargeTo === "B") {
        return "Merchant";
    } else if (chargeTo === "P") {
        return "Retail Customer";
    } else{
        return "";
    }
}

export const getChargeFrequency = (chargeFrequency) => {
    if (chargeFrequency === "M") {
        return "Monthly";
    } else if (chargeFrequency === "T") {
        return "Per Transaction";
    } else{
        return "";
    }
}

export const getCapitalOption = (capitalOption) => {
    if (capitalOption === "F") {
        return "Full Amount";
    } else if (capitalOption === "E") {
        return "Exceeded Amount";
    } else{
        return "";
    }
}

export const getWaiveType = (waiveType) => {
    if (waiveType === "F") {
        return "Full";
    } else if (waiveType === "P") {
        return "Partial";
    } else{
        return "";
    }
}

export const getWaiveBy = (waiveBy) => {
    if (waiveBy === "A") {
        return "Amount";
    } else if (waiveBy === "P") {
        return "Percentage";
    } else{
        return "";
    }
}

export const getAddressText = (addressList, addressSeqId) => {
    const address = addressList.length !== 0 ? 
    addressList.find(address => address.seqId === addressSeqId): 
    {
      addressNumber: "",
      buildingVillage: "",
      soi: "",
      street: "",
      subDistrict: "",
      district: "",
      city: "",
      zipCode: ""
    };

    const addressText = address.addressNumber + address.buildingVillage + address.soi + address.street +
        address.subDistrict + address.district + address.city + address.zipCode;

    return addressText;
}

export const getPaymentChannelLogo = (paymentChannel) => {
    return paymentChannelLogo[paymentChannel];
}

export const getLabelChange = (label) => {
    return isNullOrUndefined(labelChange[label]) ? label : labelChange[label];
}

export const toCapitalize = (lower) => {
    return lower.replace(/^\w/, c => c.toUpperCase());
}

export const stringCompare = (order, strA, strB) => {
    if (order === 'asc') return ('' + strA).localeCompare(strB);
    else return ('' + strB).localeCompare(strA);
}

export const formatAccountNo = (accountNo) => {
    try{
        return accountNo.substring(0, 3) + "-" + accountNo.substring(3,9) + "-" + accountNo.substring(9,10);
    } catch {
        return accountNo;
    }
}


export const getBadge = (transactionStatus) => {
    switch (transactionStatus) {
        case '0000' : return {text : 'CREATED', style : 'light'};
        case '1000' : return {text : 'PAYMENT SUCCESS', style : 'success'};
        case '1001' : return {text : 'VALIDATION FAILED', style : 'danger'};
        case '1002' : return {text : 'PAYMENT FAILED', style : 'danger'};
        case '1003' : return {text : 'PROCESSING', style : 'warning'};
        case '1004' : return {text : 'PENDING APPROVAL', style : 'warning'};
        case '1005' : return {text : 'CANCELLED', style : 'light'};
        case '9999' : return {text : 'ERROR', style : 'danger'};
        default : return {text : transactionStatus, style : 'dark'};
    }
}

export const getUserStatusBadge = (status) => {
    switch (status) {
    case 'I' : return {text : 'INACTIVE', style : 'secondary'};
    case 'A' : return {text : 'ACTIVE', style : 'success'};
    case 'L' : return {text : 'LOCKED', style : 'danger'};
    default : return {text : 'N/A', style : 'dark'};
    }
}

export const booleanToYesNo = (b) => {
    return b ? "Y" : "N";
}

export const yesNoToBoolean = (yn) => {
    return yn === "Y";
}